

export const getCurrentDateTime = () => {

   const current = new Date();
   const year = current.getFullYear();
   const day = current.getDate();
   const month = current.getMonth()+1;
   let fullMonth = month.toString();
   if (month < 10){
         fullMonth = "0" + fullMonth;
   }
   let fullDay = day.toString();
   if (day < 10){
        fullDay = "0" + fullDay;
   }
   const date = year + "/" + fullMonth + "/" + fullDay;
   const now = new Date();
   const time24 = now.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
   const timeObj = {date: date, time: time24, dateTime: date + "%" + time24};
              
   return timeObj;
}
export default getCurrentDateTime;
 




